export const en = {
  or: 'or',
  browseFiles: 'Browse Files',
  dragAndDropFileHere: 'Drag & Drop File Here',
};
